import { render, staticRenderFns } from "./OnePersonOneCodeTable.vue?vue&type=template&id=42719df2&scoped=true"
import script from "./OnePersonOneCodeTable.vue?vue&type=script&lang=js"
export * from "./OnePersonOneCodeTable.vue?vue&type=script&lang=js"
import style0 from "./OnePersonOneCodeTable.vue?vue&type=style&index=0&id=42719df2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42719df2",
  null
  
)

export default component.exports